





































import Vue, { PropType } from 'vue';
import Icon from '~/components/builders/Base/Icon.vue';
import IconBtn from '~/components/builders/IconBtn.vue';

// Types
import { WorkExperience } from '~/services/CandidateService';
import { format } from '~/utils/date-fns';

export default Vue.extend({
    name: 'WorkExperienceListItem',
    props: {
        we: {
            type: Object as PropType<WorkExperience>,
            required: true,
        },
        editMode: Boolean,
        disableSidebar: Boolean,
    },
    computed: {
        startText(): string {
            return format(this.we.start, 'MMM yyyy');
        },
        endText(): string {
            if (this.we.end) {
                return format(this.we.end, 'MMM yyyy');
            }
            return this.$t('profile.workExperience.present').toString();
        },
    },
    components: { Icon, IconBtn },
});
